export default __webpack_public_path__ + "static/media/13.1ab48a2e.png";